import lazyWithRetry from 'services/lazyWithRetry';
import { Features, Roles } from 'typings/enums';
import { RouteCollection } from 'typings/shared';

const basePath = '/provider';

const ListPage = lazyWithRetry(() => import('./List'));
const AddPage = lazyWithRetry(() => import('./Add'));
const EditPage = lazyWithRetry(() => import('./Edit'));
const ShowPage = lazyWithRetry(() => import('./Show'));

export const paths = {
    LIST: `${basePath}/list`,
    ADD: `${basePath}/add`,
    EDIT: `${basePath}/:id/edit`,
    SHOW: `${basePath}/:id/show`,
};

export const routes: RouteCollection = {
    list: {
        exact: false,
        path: paths.LIST,
        component: ListPage,
        roles: [Roles.MANAGER],
        features: [Features.RENTAL_MANAGER],
    },
    add: {
        exact: false,
        path: paths.ADD,
        component: AddPage,
        roles: [Roles.MANAGER],
        features: [Features.RENTAL_MANAGER],
    },
    edit: {
        exact: true,
        path: paths.EDIT,
        component: EditPage,
        roles: [Roles.MANAGER],
        features: [Features.RENTAL_MANAGER],
    },
    show: {
        exact: true,
        path: paths.SHOW,
        component: ShowPage,
        roles: [Roles.MANAGER],
        features: [Features.RENTAL_MANAGER],
    },
};
